import { notification } from "antd";
import axios from "axios";
const { handlerError } = require("utils");

export const getAllExpenses = async () => {
  try {
    const { data } = await axios.get(`/expense`);
    return data.data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};
export const updateAllExpenses = async (data) => {
  try {
    const res = await axios.put(`/expense/status`, { expenses: data });
    notification.success({ message: "Salvo com sucesso" });
    return res.data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};
